import { useMemo } from 'react';
import { usePreset } from '@splunk/dashboard-context';
import type {
    InputDefinition,
    LayoutItemType,
    VisualizationDefinition,
} from '@splunk/dashboard-types';

export const useItemName = ({
    type,
    itemDefinition,
}: {
    type?: LayoutItemType;
    itemDefinition?: InputDefinition | VisualizationDefinition;
}): string | undefined => {
    const preset = usePreset();
    return useMemo(
        () =>
            type === 'input'
                ? preset.getInputName(itemDefinition)
                : preset.getVisualizationName(itemDefinition),
        [preset, type, itemDefinition]
    );
};
